// ListingModal.js
import React from 'react';
import { Dialog, TextField, Select, MenuItem, Stack, Button } from '@mui/material';

const ListingModal = ({
  open,
  onClose,
  title,
  price,
  condition,
  listingFormat,
  listingDuration,
  setTitle,
  setPrice,
  setCondition,
  setListingFormat,
  setListingDuration,
  onSave
}) => {
  const fmt = listingFormat || 'FIXED_PRICE';
  return (
    <Dialog open={open} onClose={onClose}>
      <div style={{ padding: '20px', minWidth: '300px' }}>
        <h3>Edit Listing</h3>
        <TextField
          label="Listing Title"
          fullWidth
          margin="normal"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          label="Listing Price"
          type="number"
          fullWidth
          margin="normal"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
        <Select
          value={condition}
          onChange={(e) => setCondition(e.target.value)}
          fullWidth
          displayEmpty
        >
          <MenuItem value="">Select Condition</MenuItem>
          <MenuItem value="Near Mint">Near mint or better: Comparable to a fresh pack pulled card</MenuItem>
          <MenuItem value="Lightly Played">Lightly Played</MenuItem>
          <MenuItem value="Moderately Played">Moderately Played</MenuItem>
          <MenuItem value="Heavily Played">Heavily Played</MenuItem>
        </Select>

        <Select
          value={fmt}
          onChange={(e) => setListingFormat(e.target.value)}
          fullWidth
          displayEmpty
          style={{ marginTop: 16 }}
        >
          <MenuItem value="FIXED_PRICE">Fixed Price</MenuItem>
          <MenuItem value="AUCTION">Auction</MenuItem>
        </Select>

        {fmt === 'AUCTION' && (
          <Select
            value={listingDuration || 'DAYS_3'}
            onChange={(e) => setListingDuration(e.target.value)}
            fullWidth
            displayEmpty
            style={{ marginTop: 16 }}
          >
            <MenuItem value="DAYS_1">1 day</MenuItem>
            <MenuItem value="DAYS_3">3 days</MenuItem>
            <MenuItem value="DAYS_5">5 days</MenuItem>
            <MenuItem value="DAYS_7">7 days</MenuItem>
            <MenuItem value="DAYS_10">10 days</MenuItem>
          </Select>
        )}
        <Stack direction="row" spacing={2} justifyContent="flex-end" marginTop={2}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={onSave}>Save</Button>
        </Stack>
      </div>
    </Dialog>
  );
};

export default ListingModal;
